module.exports = __webpack_public_path__ + "static/media/mpl-logo.50f0f43f.png";